// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"detail-header__wrapper___17S9A","toggle-navigation":"detail-header__toggle-navigation___1vgEo","text":"detail-header__text___3XUXt","textonly":"detail-header__textonly___1pGGL","textWithIcon":"detail-header__textWithIcon___2wcYj","title":"detail-header__title___3LJ2A","subtitle":"detail-header__subtitle___2Sj_1","text-only":"detail-header__text-only___3MQCn","icon":"detail-header__icon___2MS65"};


//////////////////
// WEBPACK FOOTER
// ./app/components/shared/DetailHeader/detail-header.scss
// module id = 939
// module chunks = 0